export const OPEN_REQUEST_CALLBACK_MODAL_HASH = 'openModalRequestCallbackMotorwayMove';

export const MOTORWAY_MOVE_UNAUTHORISED_PARAM = 'motorwaymove';
